module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TimeRange', {
    attrs: {
      "reservation": _vm.reservation,
      "availability": _vm.availability
    },
    on: {
      "selection": _vm.handleExtend
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75d30d52!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/extend-reservation/TimeRangeWrapper.vue
// module id = 2589
// module chunks = 1